// @ts-nocheck
// @ts-ignore

import React, { useCallback, useEffect, useState } from "react";

import "./appointments.css";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";

import { Grid, LinearProgress } from "@mui/material";

import axios from "axios";

import waitIcon from "./waitIcon.png";

import { authHeader } from "auth/authHeader";
import { getToken } from "auth/authenticate";

import DetailsModal from "pages/appointment/components/DetailsModal";

import { AppointmentListItem } from "./components/AppointmentListItem";

import { CommentsModal } from "./components/CommentsModal";

import { ChangeAppointmentModal } from "./components/ChangeAppointmentModal";

// import { ReviewModal } from "./components/RewiewModal";

import {
  APPOINTMENT_STATUS,
  NOTIFICATION_ACTIONS,
  TIME_FILTER,
} from "constants/constants";

import PaginationComponent from "components/common/pagination/PaginationComponent";

import { useNavigate, useParams } from "react-router-dom";

/* =========================================================
 * FILTER COMPATIBILITY
 * ======================================================= */

/*
 * Some existing branches used FUTURE while the newer
 * appointment API terminology uses UPCOMING.
 *
 * Prefer UPCOMING when available without breaking an older
 * constants file during this migration.
 */
const UPCOMING_TIME_FILTER = TIME_FILTER.UPCOMING ?? TIME_FILTER.FUTURE;

/* =========================================================
 * DIALOG STYLES
 * ======================================================= */

const SendDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  backdropFilter: "blur(5px)",

  backgroundColor: "rgba(255, 255, 255, 0.1)",
}));

const SendDialog2 = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  backdropFilter: "blur(5px)",

  backgroundColor: "rgba(255, 255, 255, 0.1)",
}));

const EditDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },

  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },

  backdropFilter: "blur(5px)",

  backgroundColor: "rgba(255, 255, 255, 0.1)",
}));

/* =========================================================
 * APPOINTMENTS
 * ======================================================= */

const Appointments = () => {
  const params = useParams();
  const navigate = useNavigate();

  /* =====================================================
   * APPOINTMENT LIST
   * =================================================== */

  const [doctorData, setDoctorData] = useState([]);

  /*
   * Full loading:
   *
   * - first load
   * - filter change
   * - pagination
   */
  const [loading, setLoading] = useState(false);

  /*
   * Soft refresh:
   *
   * Keep existing appointment rows visible while obtaining
   * fresh server data.
   */
  const [refreshing, setRefreshing] = useState(false);

  const [loadError, setLoadError] = useState(null);

  /* =====================================================
   * FILTER + PAGINATION
   * =================================================== */

  const [timeFilter, setTimeFilter] = useState(TIME_FILTER.ALL);

  const [page, setPage] = useState(1);

  const [pageCount, setPageCount] = useState(0);

  const limit = 10;

  const [offset, setOffset] = useState(0);

  /* =====================================================
   * SELECTED APPOINTMENT
   * =================================================== */

  const [selectedAppointment, setSelectedAppointment] = useState(null);

  const [openDetails, setOpenDetails] = useState(false);

  /* =====================================================
   * OTHER APPOINTMENT UI
   * =================================================== */


  const [changeAppointmentOpen, setChangeAppointmentOpen] = useState(false);

  const [sendDialogOpen, setSendDialogOpen] = useState(false);

  const [sendDialog2Open, setSendDialog2Open] = useState(false);


  /* =====================================================
   * CHANGE-APPOINTMENT STATE
   * =================================================== */

  const [dateTime, setDateTime] = useState(new Date());

  const [activeSlotMulti, setActiveSlotMulti] = useState({
    values: [],
  });

  /* =====================================================
   * EDIT-DIALOG STATE
   * =================================================== */

  const [title1] = useState();

  const [value1] = useState();

  /* =====================================================
   * LOAD APPOINTMENTS
   *
   * silent = false
   * → normal LinearProgress loader
   *
   * silent = true
   * → keep existing list visible
   * → animate refresh button instead
   * =================================================== */

  const loadAllAppointments = useCallback(
    async ({ silent = false } = {}) => {
      if (silent) {
        setRefreshing(true);
      } else {
        setLoading(true);
      }

      setLoadError(null);

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}appointment/patient`,
          {
            params: {
              timeFilter,
              offset,
              limit,
            },

            headers: authHeader(),
          },
        );

        const appointments = response?.data?.data?.data ?? [];

        const dataCount = response?.data?.data?.dataCount ?? 0;

        const nextPageCount = Math.ceil(dataCount / limit);

        /*
         * ===============================================
         * PAGINATION SELF-RECOVERY
         * ===============================================
         *
         * Example:
         *
         * Before:
         *   page = 4
         *   pageCount = 4
         *
         * After cancel/filter:
         *   pageCount = 3
         *
         * The old implementation remained on offset 30
         * and displayed a blank page.
         *
         * We now automatically move back to the final
         * valid page.
         */
        if (nextPageCount > 0 && page > nextPageCount) {
          setPage(nextPageCount);

          setOffset((nextPageCount - 1) * limit);

          return;
        }

        /*
         * Genuine empty result.
         */
        if (dataCount === 0) {
          setDoctorData([]);
          setPageCount(0);

          if (page !== 1) {
            setPage(1);
            setOffset(0);
          }

          return;
        }

        setDoctorData(appointments);

        setPageCount(nextPageCount);
      } catch (error) {
        console.error("Unable to load appointments", error);

        setLoadError("Unable to load appointments. Please try again.");
      } finally {
        if (silent) {
          setRefreshing(false);
        } else {
          setLoading(false);
        }
      }
    },
    [timeFilter, offset, page],
  );

  /* =====================================================
   * INITIAL / PAGE / FILTER LOAD
   * =================================================== */

  useEffect(() => {
    loadAllAppointments();
  }, [loadAllAppointments]);

  /* =====================================================
   * MANUAL SOFT REFRESH
   * =================================================== */

  const handleRefresh = async () => {
    if (loading || refreshing) {
      return;
    }

    await loadAllAppointments({
      silent: true,
    });
  };

  /* =====================================================
   * PAGINATION
   * =================================================== */

  const handleChange = (value) => {
    if (value < 1 || value === page || (pageCount > 0 && value > pageCount)) {
      return;
    }

    setPage(value);

    setOffset((value - 1) * limit);
  };

  /* =====================================================
   * FILTER
   * =================================================== */

  const handleTimeFilterChange = (event) => {
    const nextFilter = event.target.value;

    /*
     * Always return to the first page when changing filter.
     *
     * This prevents stale pagination offsets from one filter
     * being reused for another filter.
     */
    setPage(1);
    setOffset(0);

    setTimeFilter(nextFilter);
  };

  /* =====================================================
   * LOAD ONE APPOINTMENT FROM NOTIFICATION
   * =================================================== */

  const getSingleAppointment = useCallback(async () => {
    if (!params?.action || !params?.id) {
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}appointment/${params.id}`,
        {
          headers: authHeader(),
        },
      );

      const appointment = response?.data?.data?.[0];

      if (!appointment) {
        return;
      }

      switch (params.action) {
        case NOTIFICATION_ACTIONS.NEXT_APPOINTMENT:
          setSelectedAppointment(appointment);

          setOpenDetails(true);

          break;

        case NOTIFICATION_ACTIONS.CHANGE_TIME:
          setSelectedAppointment(appointment);

          setChangeAppointmentOpen(true);

          setOpenDetails(false);

          break;

        default:
          break;
      }
    } catch (error) {
      console.error("Unable to load appointment", error);
    }
  }, [params?.action, params?.id]);

  useEffect(() => {
    if (params?.action) {
      getSingleAppointment();
    }
  }, [params?.action, getSingleAppointment]);

  /* =====================================================
   * DETAILS
   * =================================================== */

  /* =====================================================
   * CANCEL APPOINTMENT
   * =================================================== */

  const cancelAppointment = async () => {
    if (!selectedAppointment?.appointmentId) {
      return;
    }

    setLoading(true);

    try {
      const bodyFormData = new FormData();

      bodyFormData.append("status", APPOINTMENT_STATUS.CANCELED);

      await axios({
        method: "put",

        url:
          `${process.env.REACT_APP_BACKEND_URL}appointment/patient/` +
          `${selectedAppointment.appointmentId}`,

        data: bodyFormData,

        headers: {
          "Content-Type": "multipart/form-data",

          Authorization: `Bearer ${getToken()}`,
        },
      });

      /*
       * No browser reload.
       *
       * Fetch fresh appointment data and let React update
       * the affected row/list.
       */
      await loadAllAppointments({
        silent: true,
      });
    } catch (error) {
      console.error("Unable to cancel appointment", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelDialogOpen = async () => {
    /*
     * Existing UX retained.
     *
     * We can refine the success dialog semantics later
     * when the cancellation flow itself is updated in R2.
     */
    setSendDialogOpen(true);

    setOpenDetails(false);

    await cancelAppointment();
  };

  /* =====================================================
   * CONSULTATION NAVIGATION
   *
   * IMPORTANT:
   *
   * This no longer starts Agora.
   *
   * It only navigates to AppointmentConsultation, where
   * Phase C's authoritative consultation-context API is
   * loaded.
   * =================================================== */

  const handleConsultationOpen = (appointment) => {
    if (!appointment?.appointmentId) {
      return;
    }

    setOpenDetails(false);

    navigate(`/appointment-consultation/${appointment.appointmentId}`, {
      /*
       * Route state is optional convenience only.
       *
       * AppointmentConsultation will fetch authoritative
       * consultation context independently.
       */
      state: {
        appointment,
      },
    });
  };

  /* =====================================================
   * COMMENTS / REVIEW
   * =================================================== */

  // const handleReviewClose = () => {
  //   setReview(false);
  // };

  /* =====================================================
   * SUCCESS DIALOG
   * =================================================== */

  const handleSendDialogOpen = () => {
    setSendDialogOpen(true);
  };

  const handleSendDialogClose = () => {
    setSendDialogOpen(false);
  };

  /* =====================================================
   * CHANGE-APPOINTMENT DIALOG
   * =================================================== */

  const handleSendDialog2Open = () => {
    setSendDialog2Open(true);

    setChangeAppointmentOpen(false);
  };

  const handleSendDialog2Close = () => {
    setSendDialog2Open(false);
  };

  /*
   * This callback should only represent successful completion
   * if ChangeAppointmentModal invokes it after its mutation
   * succeeds.
   *
   * We should verify that component separately.
   */
  const handleChangeAppointmentComplete = async () => {
    setChangeAppointmentOpen(false);

    handleSendDialogOpen();

    await loadAllAppointments({
      silent: true,
    });
  };

  /* =====================================================
   * EDIT DIALOG
   * =================================================== */

  const handleUpdateValue = () => {
    const value = document.forms["dialogForm"]?.["txtUpdatedValue"]?.value;

    if (!value) {
      alert("Please enter Value...");

      return false;
    }

    // setEditDialogOpen(false);

    return true;
  };

  // const handleEditDialogClose = () => {
  //   setEditDialogOpen(false);
  // };

  /* =====================================================
   * MULTI-SLOT SELECTION
   * =================================================== */

  const handleMultiSlots = (slot) => {
    setActiveSlotMulti((previous) => {
      const current = previous.values || [];

      if (current.includes(slot)) {
        return {
          values: current.filter((value) => value !== slot),
        };
      }

      return {
        values: [...current, slot],
      };
    });
  };

  /* =====================================================
   * RENDER
   * =================================================== */

  return (
    <>
      {/* ==================================================
          COMMENTS
         ================================================== */}

      {/* <CommentsModal
        chatBoxOpen={chatBoxOpen}
        handleChatBoxClose={handleChatBoxClose}
      /> */}

      {/* ==================================================
          EDIT DIALOG
         ================================================== */}

      {/* <EditDialog
        aria-labelledby="appointment-edit-dialog"
        open={editDialogOpen}
        fullWidth
        maxWidth="xs"
      >
        <form action="#" name="dialogForm">
          <DialogContent className="editDialogContent">
            <p>Change {title1}</p>

            <input type="text" name="txtUpdatedValue" placeholder={value1} />
          </DialogContent>

          <DialogActions className="editDialogAction">
            <Button onClick={handleUpdateValue} className="editDialogDoneBtn">
              Save
            </Button>

            <Button
              variant="text"
              className="cancelBtn"
              onClick={handleEditDialogClose}
            >
              Cancel
            </Button>
          </DialogActions>
        </form>
      </EditDialog> */}

      {/* ==================================================
          SUCCESS DIALOG
         ================================================== */}

      <SendDialog
        onClose={handleSendDialogClose}
        aria-labelledby="appointment-success-dialog"
        open={sendDialogOpen}
      >
        <DialogContent className="sendDialogContent">
          <img
            alt="Success"
            src="https://cdn.pixabay.com/photo/2017/09/29/00/30/checkmark-icon-2797531_960_720.png"
            width={50}
            height={50}
          />

          <h3>Sending Successfully</h3>

          <p>Sending Success</p>
        </DialogContent>

        <DialogActions className="sendDialogAction">
          <Button
            autoFocus
            onClick={handleSendDialogClose}
            className="SendDialogDoneBtn"
          >
            Done
          </Button>
        </DialogActions>
      </SendDialog>

      {/* ==================================================
          WAIT DIALOG
         ================================================== */}

      <SendDialog2
        onClose={handleSendDialog2Close}
        aria-labelledby="appointment-wait-dialog"
        open={sendDialog2Open}
      >
        <DialogContent className="sendDialogContent">
          <img alt="Please wait" src={waitIcon} width={50} height={50} />

          <h3>Please wait</h3>

          <p>The appointment change request is being processed.</p>
        </DialogContent>

        <DialogActions className="sendDialogAction">
          <Button
            autoFocus
            onClick={handleSendDialog2Close}
            className="SendDialogDoneBtn"
          >
            Done
          </Button>
        </DialogActions>
      </SendDialog2>

      {/* ==================================================
          CHANGE APPOINTMENT
         ================================================== */}

      {selectedAppointment && (
        <ChangeAppointmentModal
          dateTime={dateTime}
          setDateTime={setDateTime}
          values={activeSlotMulti.values}
          changeAppointmentOpen={changeAppointmentOpen}
          handleSendDialog2Open={handleSendDialog2Open}
          handleChangeAppointmentClose={handleChangeAppointmentComplete}
          handleMultiSlots={handleMultiSlots}
          appointment={selectedAppointment}
        />
      )}

      {/* ==================================================
          REVIEW
         ================================================== */}

      {/* <ReviewModal
        chatBoxOpen={review}
        handleReviewClose={handleReviewClose}
        appointment={selectedAppointment}
      /> */}

      {/* ==================================================
          APPOINTMENTS PAGE
         ================================================== */}

      <div className="appointmentMain2">
        {/* ================================================
            TOOLBAR
           ================================================ */}

        <Grid
          container
          spacing={2}
          alignItems="center"
          className="appointmentToolbar"
          paddingY={0}
          paddingX={3}
        >
          <Grid item xs={12} md={7}>
            <Box className="appointmentPageHeading">
              <h3>All Appointments</h3>

              <Tooltip
                title={refreshing ? "Refreshing..." : "Refresh appointments"}
              >
                {/*
                 * MUI Tooltip cannot attach directly to a
                 * disabled button, hence the span wrapper.
                 */}
                <span>
                  <IconButton
                    aria-label="Refresh appointments"
                    disabled={loading || refreshing}
                    onClick={handleRefresh}
                    className={
                      refreshing
                        ? "appointmentRefreshButton refreshing"
                        : "appointmentRefreshButton"
                    }
                  >
                    <RefreshOutlinedIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </Box>
          </Grid>

          {/* ==============================================
              FILTER
             ============================================== */}

          <Grid item xs={12} md={5}>
            <Box className="appointmentFilterWrap" m={2}>
              <FormControl size="small" className="filterAppointment">
                <InputLabel id="filter-appointments-label">Show</InputLabel>

                <Select
                  labelId="filter-appointments-label"
                  id="filter-appointments"
                  value={timeFilter}
                  label="Show"
                  onChange={handleTimeFilterChange}
                >
                  <MenuItem value={TIME_FILTER.ALL}>All appointments</MenuItem>

                  <MenuItem value={TIME_FILTER.PRESENT}>Today</MenuItem>

                  {UPCOMING_TIME_FILTER && (
                    <MenuItem value={UPCOMING_TIME_FILTER}>Upcoming</MenuItem>
                  )}

                  <MenuItem value={TIME_FILTER.PAST}>Past</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Grid>
        </Grid>

        {/* ================================================
            APPOINTMENT LIST
           ================================================ */}

        <Box className="appointmentListContainer">
          {/*
           * Main loader:
           *
           * visible for initial load, page changes,
           * and filter changes.
           *
           * Existing rows remain for manual soft refresh.
           */}
          {loading && <LinearProgress className="appointmentListLoader" />}

          {/*
           * Do not display stale rows beneath an error
           * produced by a normal load.
           *
           * During manual soft refresh, existing rows stay
           * visible because refreshing !== loading.
           */}
          {!loadError && (
            <div className="scroll">
              {doctorData.map((appointment) => (
                <AppointmentListItem
                  key={appointment.appointmentId}
                  appointment={appointment}
                />
              ))}
            </div>
          )}

          {/* ==============================================
              ERROR
             ============================================== */}

          {loadError && !loading && (
            <Box className="appointmentEmptyState">
              <h3>Couldn't load appointments</h3>

              <p>{loadError}</p>

              <Button
                variant="outlined"
                onClick={handleRefresh}
                disabled={refreshing}
              >
                Try again
              </Button>
            </Box>
          )}

          {/* ==============================================
              EMPTY FILTER RESULT
             ============================================== */}

          {!loadError && !loading && doctorData.length === 0 && (
            <Box className="appointmentEmptyState">
              <h3>No appointments found</h3>

              <p>No appointments match the selected filter.</p>
            </Box>
          )}

          {/* ==============================================
              DETAILS MODAL
             ============================================== */}

          {selectedAppointment && (
            <DetailsModal
              appointment={selectedAppointment}
              open={openDetails}
              handleClose={() => setOpenDetails(false)}
              handleChangeAppointmentOpen={() => {
                setChangeAppointmentOpen(true);

                setOpenDetails(false);
              }}
              handleCancelDialogOpen={handleCancelDialogOpen}
              /*
               * New consultation navigation.
               *
               * DetailsModal must eventually use this instead
               * of handleVideoCallOpen / direct Agora.
               */
              handleConsultationOpen={handleConsultationOpen}
            />
          )}
        </Box>

        {/* ================================================
            PAGINATION
           ================================================ */}

        {pageCount > 1 && (
          <Box className="appointmentPagination">
            <PaginationComponent
              count={pageCount}
              page={page}
              onChangeItem={handleChange}
            />
          </Box>
        )}
      </div>
    </>
  );
};

export { Appointments };
